import 'regenerator-runtime/runtime';
import { customEvents } from './utils/custom-events';
import { on } from './utils/events-actions';

// MAIN CSS IMPORT
// import '../scss/main.scss';


/* eslint-disable-next-line */
__webpack_public_path__ = window.__webpack_public_path__

export default class App {
	init() {
		console.log('app starts');
		this.importLayout();
		this.initDataLayer();
	}

	importLayout() {
		let htmlTag = document.querySelector('html');
		let layout = (htmlTag.dataset.jsLayout && htmlTag.dataset.jsLayout.length >0)
			? htmlTag.dataset.jsLayout
			: 'IndexLayout';
		import( /* webpackChunkName:`layout-[request]` */ /* webpackMode: "lazy" */ `./layouts/${layout}` )
			.then( ({ default: layout }) => {
				let newLayout = new layout();
				newLayout.init();
			})
			.catch(error => {
				console.error('Failed to load layout, check data-js-layout at root if correct');
				console.dir(error, error.stack);
			});
	}

	initDataLayer() {
		on(customEvents.DATA_LAYER.trigger, ({ type, payload }) => {
			console.log('\n\n\ndata layer triggered');
			if (type === 'listViewMore') {
				window.listViewMore(items);
			} else {
				utag_data[type] = payload;
			}
		});
	}
}

let app = new App();
app.init();
